import { R2_PUBLIC_BASE_URL } from "../config/storage";
import { isZh } from "../utils/language";

export default function DocumentPreview({ document, onClose }) {
  const fileUrl = `${R2_PUBLIC_BASE_URL}/${document.object_key}`;

  const url =
    document.mime_type === "application/pdf"
      ? fileUrl
      : `https://docs.google.com/gview?url=${encodeURIComponent(
          fileUrl
        )}&embedded=true`;

  const ext = document.object_key?.split(".").pop() || "";
  const titleBase = isZh() ? document.title_zh : document.title_id;
  const displayTitle = `${titleBase}.${ext}`;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content preview-dialog"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="preview-close" onClick={onClose}>
          ✕
        </button>

        <h3>{displayTitle}</h3>

        <iframe
          src={url}
          title="preview"
          style={{ width: "100%", height: "75vh", border: 0 }}
        />
      </div>
    </div>
  );


}
